<template>
  
  <div  class="rounded p-4">
    <p v-if="verificationCodeSent" class="py-4">   {{ $t('message.linkUser.verificationStep.descriptionCodeSent') }}</p>
    <p v-else class="py-4">    {{ $t('message.linkUser.verificationStep.descriptionCodeNotSent') }} </p>
    <div class="border p-4 px-6">

      <div class="w-full flex justify-around m-auto py-2">
        <div
        class="w-4/12 logo-company-change-box flex items-center justify-center pb-2"
        >
        <logo-company :user-id="parseInt(linkUserDataFormArray[step-1].companyId)"  :key="step" noSave />
      </div>
      <div class=" flex align-center justify-end text-right">
        <p>{{ linkUserDataFormArray[step-1].companyName }}</p>
      </div>
  
      </div>
    <div v-if="!verificationCodeSent">
      <zt-input outlined name="typeAccount" class="w-full my-2" v-model="email"  type="email" 
      label="Email"  data-vs-input="emailAccount" />
      <p v-if="email.length > 3 && !isValidEmail" class="text-zt-danger text-sm ml-2"> {{ $t('message.linkUser.verificationStep.invalidEmail') }}</p>
    </div>
    <div v-if="verificationCodeSent">
      <div class="content">
        <div class="flex items-center justify-center mb-10 md:mt-10">
       
          <div
            class="text-center md:text-left md:ml-5"
            :class="maxFailsExceeded ? ['mt-10', 'md:mt-0'] : null"
          >
            <div
              class="flex items-center justify-start md:justify-center md:block"
            >
        
              <div
                class="text-zt-primary-200 text-xl md:text-2xl font-medium md:mb-2"
              >
                {{ $t('message.mfa.code_authentication.title') }}
              </div>
            </div>
            <zt-alert v-if="this.mfaError"  color="warning" >
              <template slot="custom-content">
                <div class="flex justify-start items-center">
                  <zt-icon name="warning-triangle-solid" class="text-xl mr-2"></zt-icon>
                  <p class="pr-4"> {{ warningMessage}}</p>
                </div>
              </template>
            </zt-alert>
            <div  class="my-2">
              <p class="mfa-description text-base">
                {{ $t('message.mfa.code_authentication.sub_title_valid_code')  }} 
                <span class="font-bold">{{ toEmail }}</span>
              </p>
              
            </div>
           
            <div
              class="mfa-timer text-base"
              v-if="!buttonResendEnabled"
            >
              <span>
                {{
                  $t(
                    'message.mfa.code_authentication.sub_title_time_expired_code'
                  )
                }}
              </span>
              <Timer
                @endTime="enableResendButton"
                :timerStart="timerStart"
              ></Timer>
            </div>
            <div class="mfa-description text-base" v-if="buttonResendEnabled">
              <span>
                {{
                  $t('message.mfa.code_authentication.sub_title_expired_code')
                }}
                &nbsp;</span
              ><span
                class="text-black font-bold underline cursor-pointer"
               @click="sendValidationCodeAgain"
                data-vs-link="auth-mfa-link-sendvalidationcodeagain"
                >{{
                  $t('message.mfa.code_authentication.sub_title_resend_code')
                }}
              </span>
            </div>
          </div>
        </div>
        <div v-if="!(maxFailsExceeded || resendExceeded || notSendMail)" class="input-group-evenly mb-10 w-full">
          <input
          v-for="(input, index) in inputs"
          :key="index"
          :id="`codePart${index + 1}`"
          v-model="input.value"
          class="bg-zt-dark-200 mfa-input-code text-center text-zt-lg"
          maxlength="1"
          :type="isMobile ? 'number' : 'text'"
          placeholder="0"
          min="0"
          max="9"
          :ref="'inputs'+index"
          @input="moveToNextInput(index)"
          @paste="handlePaste"
        />
        </div>
      </div>
    </div>
     
    </div>
   
  </div>
</template>

<script>
import logoCompany from '@/components/commons/LogoCompany'
import index from '../../Auth/pages/mfa/codeVerification/index.vue';
import Timer from '@/modules/Auth/components/mfa/timer.vue'
import UsersLink from '@/apiClient/UsersLink'
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    logoCompany,
    index,
    Timer,
    ValidationProvider
  },
  props: {
    linkUserDataFormArray: {
      type: Array,
      required: true
    },
    step: {
      type: Number,
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    verificationCodeSent: {
      type: Boolean,
      default: false
    },
    toEmail: {
      type: String,
      default: ''
    },
    mfaError: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      email: '',
      maxFailsExceeded: false,
      resendExceeded: false,
      notSendMail: false,
      userEmail: '',
      buttonResendEnabled: false,
      timerStart: false,
      errors: [],
      inputs: [
        { value: "" },
        { value: "" },
        { value: "" },
        { value: "" },
        { value: "" },
        { value: "" }
      ],
    }
  
  },
  created() {
      this.usersLink = new UsersLink()
    },
  computed: {
    warningMessage() {
      return  this.mfaError ? this.$t(`message.errorReference.${this.mfaError}`) : null
    },
    isNewEmail() {
      return this.toEmail.includes('*');
   },
   isValidEmail() {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.email);
    },
  },
  methods: {
    enableResendButton() {
      this.timerStart = false
      this.buttonResendEnabled = true
      //this.wrongCode = false
      this.resendExceeded = false
      this.notSendMail = false
    },
    handlePaste(e) {
      e.preventDefault();
      const paste = e.clipboardData.getData('text');
      const pasteArray = paste.split('');
      this.inputs.forEach((input, index) => {
        input.value = pasteArray[index] || '';
      });
    },
    moveToNextInput(index) {
      if (this.inputs[index].value.length === 1 && index !== this.inputs.length - 1) {
        this.$nextTick(() => {
          let next = this.$refs['inputs' + (index + 1)];
          next.focus()
        });
      }
    },
    resetCodeFields() {
      const initialValue = { value: "" };
      this.inputs = Array.from({ length: 6 }, () => ({ ...initialValue }));
    },
    sendValidationCodeAgain() {
      this.timerStart = true
      this.buttonResendEnabled = false
      // this.wrongCode = false
      this.resetCodeFields()
      this.getVerificationCode()
    },
    getVerificationCode() {
      const sendEmailIfItsNew = this.toEmail.includes('*') ? null : this.toEmail
      this.usersLink.reSendValidationCode(this.linkUserDataFormArray[this.step - 1].userId, sendEmailIfItsNew)
    }
  }


}
</script>

<style lang="scss" scoped>
.logo-company-change-box{ 
  max-width: 100px;
}
.mfa-input-code {
  width: 3.563rem;
  height: 2.438rem;
}

.mfa-logo-verification {
  width: 6.5rem;
  height: 6.25rem;
}

.mfa-logo-verification-mobile {
  width: 3.19rem;
  height: 3.19rem;
}

.mfa-description {
  line-height: 1.43;
  color: #4f4f4f;
}

.mfa-timer {
  color: #949494;
}

input[type='number'] {
  -moz-appearance: textfield;
}
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.input-group-evenly {
  display: flex;
  justify-content: space-evenly;
}

::v-deep {
  .zt-button {
    box-shadow: none;
  }
}
</style>